import {useSettingsQuery} from '../../../common/providers/ApiInterface'
import {ProductionLine} from '../../types/departmentConfig'

export const useProductionLines = (areaId?: string) => {
  return useSettingsQuery('upmProductionLines', [], {
    gcTime: 0,
    enabled: !!areaId,
    retry: false,
    staleTime: 0,
    select: (data: ProductionLine[]) => data.filter((line) => line.areaId === areaId)
  })
}

export const QueryKey = 'upmProductionLines'
